import * as React from "react";
import { SVGProps } from "react";

const Perlin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
    <defs>
      <style>{".cls-1{fill-rule:evenodd}"}</style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="logo-perlin_svg_Group" data-name="logo-perlin svg Group">
          <path
            id="logo-perlin_svg_Shape"
            d="M30.44 1.56v1.38a5.81 5.81 0 0 0 1.35-.77c-.46 0-.92-.61-1.38-.61Z"
            className="cls-1"
            data-name="logo-perlin svg Shape"
          />
          <path
            id="logo-perlin_svg_Shape-2"
            fill="#b4e1ff"
            fillRule="evenodd"
            d="M32.07 1.66c-.49 0-1-.08-1.47-.09h-.15A30.56 30.56 0 0 0 14.68 57.2a9.4 9.4 0 0 1-3.09-7 9.52 9.52 0 0 1 9.46-9.46l1.89-.06v-.41a9.39 9.39 0 0 1 6.47-8.93 9.18 9.18 0 0 1 2.93-.47 9.4 9.4 0 0 1 8.58 5.54 19.1 19.1 0 0 0-8.85-34.75Z"
            data-name="logo-perlin svg Shape"
          />
          <path
            id="logo-perlin_svg_Shape-3"
            fill="#90d595"
            fillRule="evenodd"
            d="M33.07 1.56c16.52 2 21.63 14.13 21.64 25.08 0 11.2-9.41 19.37-17.64 21.53a75.73 75.73 0 0 1-9.32 1.68L26.5 50a5.78 5.78 0 0 0-.88.19 6.14 6.14 0 0 0-3.95 3.56 6.05 6.05 0 0 0-.46 2.33 6.15 6.15 0 0 0 4.12 5.81c.43.1.87.18 1.32.27a31.33 31.33 0 0 0 5.43.48 30.55 30.55 0 0 0 1-61.08Z"
            data-name="logo-perlin svg Shape"
          />
          <path
            id="logo-perlin_svg_Shape-4"
            fill="#fff"
            fillRule="evenodd"
            d="M33.07 1.56H30.6c.5 0 1 .05 1.47.1a19.09 19.09 0 0 1 8.85 34.77 9.4 9.4 0 0 0-18 3.86v.4l-1.9.07a9.45 9.45 0 0 0-6.34 16.44c.6.42 1.21.8 1.84 1.18a29.85 29.85 0 0 0 8.81 3.5 6.14 6.14 0 0 1-4.12-5.8 6.06 6.06 0 0 1 .46-2.34 6.19 6.19 0 0 1 3.95-3.56 7.31 7.31 0 0 1 .88-.18l1.25-.14a78 78 0 0 0 9.32-1.69C45.3 46 54.72 37.84 54.71 26.64c0-11-5.12-23.12-21.64-25.08Z"
            data-name="logo-perlin svg Shape"
          />
          <path
            id="logo-perlin_svg_Polygon"
            d="m42 37.53-1.1-1.1Z"
            className="cls-1"
            data-name="logo-perlin svg Polygon"
          />
        </g>
        <path
          id="logo-perlin_svg_Shape-5"
          fill="#41474e"
          fillRule="evenodd"
          d="M32.08 0h-1.61a32.08 32.08 0 0 0-16.7 58.38 11.48 11.48 0 0 0 1.91 1.38 1.59 1.59 0 0 0 .55.17 31.75 31.75 0 0 0 8.71 3.39 7.09 7.09 0 0 0 1.53.35 32.54 32.54 0 0 0 5.62.5A32.09 32.09 0 1 0 32.08 0Zm-12 58.49a28.48 28.48 0 0 1-4.57-2.59 7.93 7.93 0 0 1 5.55-13.62c.62 0 1.33 0 1.92-.06a1.54 1.54 0 0 0 1.47-1.53v-.4a7.88 7.88 0 0 1 15.07-3.23 1.52 1.52 0 0 0 2 .77 1.7 1.7 0 0 0 .22-.15 20.56 20.56 0 0 0 6.64-26.57c4.08 5.29 4.76 11.82 4.76 15.51 0 10.2-8.5 17.94-16.5 20a81.89 81.89 0 0 1-10.4 1.79 7.7 7.7 0 0 0-6.61 7.6 8 8 0 0 0 .42 2.41Zm-17-26.4a29 29 0 0 1 27.84-29 17.54 17.54 0 0 1 10.48 31 10.93 10.93 0 0 0-19.92 5.06H21a11 11 0 0 0-11 11c0 .27 0 .53.06.8a28.87 28.87 0 0 1-7-18.86Zm29 29a29.08 29.08 0 0 1-6.38-.73 4.61 4.61 0 0 1 .95-8.87 84.74 84.74 0 0 0 10.81-1.88c9.1-2.39 18.78-11.27 18.77-23a28.66 28.66 0 0 0-4.1-15.5 29 29 0 0 1-20 50Z"
          data-name="logo-perlin svg Shape"
        />
      </g>
    </g>
  </svg>
);

export default Perlin;
